import { useMemo, useState } from "react";
import { useFetch } from "../../core/hooks/useFetch"
import { ApiFactory } from "../../core/config/ApiFactory";

export const useFetchCupons = () => {
    const apiPedidos = useMemo(() => ApiFactory.getApi("MS_PEDIDOS"), []);
    const [codigo, setCodigo] = useState<string | undefined>();
    const [nome, setNome] = useState<string | undefined>();
    const [ativo, setAtivo] = useState<boolean | undefined>();

    const urlInicial = `/cupons`; 
    const [url, setUrl] = useState(urlInicial);

    const handleCodigoChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setCodigo(e.target.value);
    const handleNomeChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setNome(e.target.value);
    const handleAtivoChange = (value: boolean | undefined) => setAtivo(value);

    const handleLimpar = () => {
        setUrl(urlInicial);
        setCodigo('');
        setNome('');
        setAtivo(undefined);
    }

    const handleFiltrar = () => {
        let novaUrl = urlInicial;
        const params: string[] = [];

        if(codigo) {
            params.push(`codigo=${codigo}`);
        }

        if(nome) {
            params.push(`nome=${nome}`);
        }

        if(ativo !== undefined) {
            params.push(`ativo=${ativo}`);
        }

        if(params.length > 0) {
            novaUrl = `${novaUrl}?${params.join('&')}`;
        }

        setUrl(novaUrl);
    }
    
    const { data: dados, isLoading, handleRefresh } = useFetch(apiPedidos, url);
    
    return { 
        dados, 
        isLoading, 
        handleRefresh, 
        handleCodigoChange,
        handleNomeChange,
        handleAtivoChange,
        handleLimpar,
        handleFiltrar,
        codigo,
        nome,
        ativo
    }
}

